import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { toast } from 'react-toastify';

import theme from '../lib/muiTheme';
import JWAdminLayoutSidenav from './JWAdminLayoutSidenav';
import { CircularLoading } from '../lib/components/Loading';
import jsonApiDuck from '../redux/modules/jsonApiDuck';

const mapStateToProps = store => {
  const { $$railsContextStore } = store;
  return {
    $$flash: $$railsContextStore.get('$$flash'),
  };
};

const JWAdminLayout = props => {
  const isBusy = useSelector(jsonApiDuck.selectors.isBusy);
  // React.useEffect(() => {
  //   props.$$flash.forEach(el => {
  //     const [type, message] = el;
  //     if (type === 'alert') {
  //       toast.error(message);
  //     } else if (type === 'notice') {
  //       toast.success(message);
  //     }
  //   });
  // }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ display: 'flex' }}>
        <JWAdminLayoutSidenav />
        {props.children}
      </div>
      {isBusy && <CircularLoading />}
    </ThemeProvider>
  );
};

JWAdminLayout.propTypes = {
  $$flash: PropTypes.array.isRequired,
};
JWAdminLayout.defaultProps = {};

export default connect(mapStateToProps)(JWAdminLayout);
